import React, { useEffect } from "react";

export const SearchComponent: React.FC<{
  fetchDataApi: Function;
  name?: string;
}> = ({ name, fetchDataApi }) => {
  useEffect(() => {
    if (name !== undefined) {
      const handler = setTimeout(() => {
        fetchDataApi();
      }, 1000);

      return () => clearTimeout(handler);
    }
  }, [name]);

  return <></>;
};
